// eslint-disable-next-line no-unused-vars
const styles = (theme) => ({
  loginCodeLabel: {
    fontWeight: 500,
    marginBottom: 0,
  },
  footerLeftText: {
    margin: theme.spacing(2, 0),
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  mobileNumberFormContainer: {
    marginBottom: theme.spacing(4),
  },
  smsCodeFormContainer: {
    marginBottom: theme.spacing(4),
  },
});

export default styles;
